import Cookies from 'js-cookie';
const TOGGLABLE_WRAPPER_SELECTOR = '[data-togglable-categories]';
const ACTIVE_CLASS = 'active-filter';

class TogglableCategory {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.list = this.initList();
    this.listId = this.list.getAttribute('id');
    if (!this.listId) {
      throw new Error('List must have an ID attribute set');
    }
    this.toggler = this.initToggler(this.listId);

    this.cookieName = `togglable_list_${this.listId}`;

    this.bindEvents();

    this.readSavedState();
  }

  initList() {
    let list = this.wrapper.querySelector('ul');
    if (!(list instanceof HTMLElement)) {
      throw new Error('Missing list with categories');
    }

    list.setAttribute('aria-hidden', 'true');
    return list;
  }

  initToggler(listId) {
    let toggler = this.wrapper.querySelector('h3');
    if (!(toggler instanceof HTMLElement)) {
      throw new Error('Missing toggler element');
    }

    toggler.setAttribute('tabindex', 0);
    toggler.setAttribute('aria-role', 'button');
    toggler.setAttribute('aria-expanded', 'false');
    toggler.setAttribute('aria-controls', listId);
    return toggler;
  }

  bindEvents() {
    this.toggler.addEventListener('click', event => {
      event.preventDefault();
      this.toggler.blur();
      this.toggle();
    });

    this.toggler.addEventListener('keypress', event => {
      // space or enter
      if (event.keyCode === 32 || event.keyCode === 13) {
        event.preventDefault();
        this.toggle();
      }
    });
  }

  enable() {
    this.wrapper.classList.add(ACTIVE_CLASS);
    this.toggler.setAttribute('aria-expanded', 'true');
    this.list.setAttribute('aria-hidden', 'false');

    Cookies.set(this.cookieName, 1);
  }

  disable() {
    this.wrapper.classList.remove(ACTIVE_CLASS);
    this.toggler.setAttribute('aria-expanded', 'false');
    this.list.setAttribute('aria-hidden', 'true');

    Cookies.set(this.cookieName, 0);
  }

  toggle() {
    if (this.wrapper.classList.contains(ACTIVE_CLASS)) {
      this.disable();
      return;
    }

    this.enable();
  }

  readSavedState() {
    let state = !!parseInt(Cookies.get(this.cookieName), 10);
    if (state) {
      this.enable();
    }
  }
}

class TogglableCategories {
  constructor() {
    Array.prototype.forEach.call(
      document.querySelectorAll(TOGGLABLE_WRAPPER_SELECTOR),
      el => {
        new TogglableCategory(el);
      }
    );
  }
}

export default TogglableCategories;



// WEBPACK FOOTER //
// ./src/javascripts/TogglableCategories.js